// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { GroupDetail } from "@/features/iam/group-detail";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/iam/groups/$groupName")({
  validateSearch: z.object({ t: z.string().optional(), f: z.string().optional() }),
  component: GroupDetailPage,
});

function GroupDetailPage() {
  const { groupName } = Route.useParams();
  const { t: tab, f } = Route.useSearch();
  return (
    <RequirePermission permission={PAGE_PERMISSIONS.iamGroups}>
      <GroupDetail groupName={groupName} tab={tab} initialFilters={f} />
    </RequirePermission>
  );
}
